const toast = {
  message: {
    success: 'Erfolg!',
    error: 'Etwas ist schief gelaufen.',
  },
};

export default toast;
